import Cookies from "js-cookie";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router";
import Loader from "react-spinners/RingLoader";
import config from "../../config/apiConfig";
import { getInfo } from "../../utils/hooks";
import CriticNav from "../CriticNav/CriticNav";
import Navbar from "../Navbar/Navbar";
import ChapterDetails from "./ChapterDetails/ChapterDetails";
import StoryHeader from "./StoryHeader/StoryHeader";
import Feedback from "../../Components/Feed/Feedback";
import ReactGA from "react-ga";

export type Chapter = {
    id: string;
    title: string;
};

type Story = {
    id: string;
    title: string;
    reviewed: boolean;
    author: string;
};

const mapToChapter = (data: { [key: string]: any }): Chapter => ({
    id: data.id,
    title: data.title,
});

const mapToStory = (data: { [key: string]: any }): Story => ({
    id: data.id,
    title: data.title,
    reviewed: data.is_reviewed,
    author: data.name,
});

const ReaderView: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [selected, setSelected] = useState(0);
    const [chapters, setChapters] = useState<Chapter[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [feedback, setFeedback] = useState(false);
    const [story, setStory] = useState<Story | undefined>(undefined);

    useEffect(() => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        const promise1 = fetch(
            config.BASE_URL + "/v1/get/writingtool/story/" + id + "/info",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => setStory(mapToStory(res.data)));
        const promise2 = fetch(
            config.BASE_URL + "/v1/get/writingtool/story/" + id + "/chapters",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) =>
                setChapters(res.data.map((d: any) => mapToChapter(d)))
            );
        setIsLoading(true);
        Promise.all([promise1, promise2]).finally(() => setIsLoading(false));
    }, []);

    return (
        <div className="story__container">
            <CriticNav />
            {!!story && (
                <StoryHeader
                    id={story.id}
                    title={story.title}
                    reviewed={story.reviewed}
                    writterName={""}
                    openfeed={() => setFeedback(true)}
                />
            )}
            <div style={{ display: "flex" }}>
                {isLoading ? (
                    <Loader color="blue" />
                ) : chapters.length > 0 ? (
                    <ChapterDetails
                        chapter={chapters[selected]}
                        storyId={id}
                        chapters={chapters}
                        jump={(index) => setSelected(index)}
                        goToPrevious={() => setSelected(selected - 1)}
                        goToNext={() => setSelected(selected + 1)}
                    />
                ) : null}
                {!!story && (
                    <Feedback
                        visible={feedback}
                        reviewed={story.reviewed}
                        close={() => setFeedback(false)}
                    />
                )}
            </div>
        </div>
    );
};

export default ReaderView;
